var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up-loading 1",
    clipPath: "url(#clip0_856_2422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000097469747894302416050000002917915783155835571_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.9875 11.9985C5.0125 11.9985 4.0375 11.9985 3.06484 11.9985C1.72891 11.9962 0.765625 11.0376 0.758594 9.70167C0.75625 9.23527 0.75625 8.76886 0.758594 8.30246C0.760938 7.82199 1.05156 7.51261 1.49922 7.51027C1.94687 7.50792 2.23984 7.8173 2.24453 8.29777C2.24688 8.7712 2.24219 9.24699 2.24688 9.72277C2.25156 10.2196 2.54219 10.5103 3.04375 10.5103H8.96641C9.46562 10.5103 9.75859 10.2196 9.76328 9.72277C9.76562 9.24933 9.76094 8.77355 9.76562 8.29777C9.76797 7.8173 10.0609 7.51027 10.5086 7.51027C10.9562 7.51027 11.2516 7.81964 11.2469 8.30246C11.2422 8.90949 11.275 9.52355 11.2 10.1212C11.0594 11.2181 10.1266 11.9915 9.01562 11.9962C8.00313 12.0032 6.99531 11.9985 5.9875 11.9985Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.74355 5.6915C6.85605 5.58604 6.92402 5.52744 6.98496 5.4665C7.46074 4.98604 7.93184 4.50322 8.40996 4.02744C8.7498 3.6876 9.2209 3.66416 9.52559 3.95947C9.83027 4.25479 9.81855 4.74229 9.48574 5.07979C8.51543 6.05479 7.54277 7.02744 6.56777 7.99775C6.22324 8.33994 5.77559 8.33994 5.4334 7.99775C4.45137 7.02275 3.47402 6.04541 2.49902 5.06338C2.17793 4.73994 2.17559 4.25244 2.47559 3.96182C2.77559 3.67119 3.24902 3.68525 3.5748 4.00869C4.05996 4.4915 4.53574 4.98135 5.01621 5.4665C5.07715 5.52979 5.14512 5.58838 5.24355 5.67979C5.25059 5.54619 5.25762 5.45947 5.25762 5.37041C5.25762 3.8376 5.25527 2.30244 5.25996 0.769629C5.2623 0.193067 5.76621 -0.149121 6.29355 0.0571289C6.58418 0.169629 6.74355 0.422754 6.74355 0.793066C6.7459 2.30947 6.7459 3.82588 6.74355 5.34463V5.6915Z",
    fill: "#1253FA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_2422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLoading);
export default __webpack_public_path__ + "static/media/down-loading.21b8b8d89cda39261ad98f072a5d8c18.svg";
export { ForwardRef as ReactComponent };